/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Image, Link } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { YoutubeEmbed } from 'components/youtubeEmbed'

// TODO Set the correct article ID here
const ARTICLE_ID = '824769522022'

const fourColumnGrid = window.innerWidth > 1200
const twoColumnGrid = window.innerWidth > 599 && window.innerWidth < 1199
const oneColumnGrid = window.innerWidth < 600
const width500 = window.innerWidth < 1200
// const isMobileSmall = window.innerWidth < 376

const Quote = ({ children, author }) => {
  if (!children) return null
  return (
    <blockquote className='quote'>
      <p>{children}</p>
      {author && <span>{author}</span>}
    </blockquote>
  )
}

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />
      <header className='ui titleImage'>
        <div className='ui container cover'>
          <div className='ui header headline'>
            <div className='headerWrapper'>
              <h1>Tout ce que vous devez savoir sur les tests Covid-19</h1>
              <h2>
                Les tests ont une importance capitale dans le cadre des
                nouvelles mesures de lutte contre la propagation du coronavirus.
                À quel moment faut-il opter pour tel ou tel test et pourquoi
                faut-il souvent se faire tester deux fois?
              </h2>
            </div>
          </div>
        </div>
        <div className='virus' />
        <div className='Wrapper'>
          <div className='leftHand' />
          <div className='rightHand' />
        </div>
      </header>
      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Barbara Reye, Patrick Vögeli</div>
            <div className='ta updated'>Mis à jour le 23 décembre 2021</div>
          </div>
          <div className='ta text'>
            <p>
              Les tests PCR et les tests antigéniques deviennent encore plus
              importants dans la lutte contre la pandémie en raison du nombre
              élevé de cas, des fêtes de fin d’année qui approchent et de la
              menace de la vague Omicron. Nous avons rassemblé les faits les
              plus importants concernant les différentes sortes de tests et
              expliquons ce à quoi il faut faire particulièrement attention, ce
              qui change pour les entrées en Suisse et qui prend en charge les
              coûts liés aux tests de dépistage.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Combien de fois et quand doit-on se faire tester lors d’une entrée
              en Suisse?
            </h4>
            <p>
              À quelques exceptions près, toutes les personnes entrant en Suisse
              doivent présenter un formulaire d'entrée et un résultat de test
              négatif (voir graphique). Après consultation des cantons, le
              Conseil fédéral a toutefois adapté le régime en matière de tests.
              Avant l'entrée en Suisse, en plus des tests PCR datant de moins de
              septante-deux heures, les tests rapides antigéniques datant de
              moins de vingt-quatre heures sont désormais acceptés. Les
              personnes vaccinées et guéries ne doivent plus faire de deuxième
              test quatre à sept jours après leur entrée en Suisse.
            </p>
            <h5 className='graphicTitle travel'>
              Nouvelles règles concernant l'entrée en Suisse
            </h5>
            <div className='graphicSub'>À partir du 20 décembre 2021</div>
            <Image
              file={
                browserCheck.isMobile
                  ? require('../../images/travel-mobile.svg')
                  : require('../../images/travel-desktop.svg')
              }
              className='cbImage travel'
              // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
              // source='Quelle: Robert Koch Institut'
            />
            <div className='listWrapper'>
              <div className='col'>
                <div className='listTitle bold'>
                  Ni test ni formulaire pour:
                </div>
                <ul>
                  <li>Chauffeurs</li>
                  <li>Frontaliers***</li>
                  <li>Personnes des régions frontalières***</li>
                </ul>
              </div>
              <div className='col'>
                <div className='listTitle bold'>Pas de test pour:</div>
                <ul>
                  <li>Enfants de moins de 16 ans</li>
                  <li>Personnes dispensées de dépistage</li>
                  <li>Urgences médicales</li>
                </ul>
              </div>
            </div>
            <div className='note travel'>
              <div>
                * Test PCR (de moins de 72h) ou test rapide antigénique (de
                moins de 24h).
              </div>
              <div>** Le résultat du test doit être communiqué au canton.</div>
              <div>
                *** Pour entrer en Suisse par avion ou en bus longue distance,
                il faut un test et le formulaire d'entrée.
              </div>
            </div>
            <div className='source travel'>
              Source: Office fédéral de la santé publique OFSP
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Quand les coûts des tests sont-ils pris en charge ?
            </h4>
            <p>
              Les coûts de certains tests menant à un certificat Covid sont
              désormais à nouveau pris en charge. Concrètement, ce sont les
              tests rapides antigéniques et les tests salivaires PCR groupés
              (pooling) qui seront pris en charge. Les autotests, les tests PCR
              individuels et les tests d'anticorps ne sont pas pris en charge.
              Les coûts des tests PCR individuels chez les personnes présentant
              des symptômes de la maladie, chez les personnes ayant eu un
              contact avec une personne infectée et chez les personnes dont le
              résultat du test groupé s’est révélé positif sont également pris
              en charge.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Que signifie la règle des «2G+» pour les discothèques et les
              activités sans masque ?{' '}
            </h4>
            <p>
              Désormais, seules les personnes vaccinées et guéries, qui peuvent
              présenter un résultat de test négatif, sont admises (2G+) dans les
              lieux où ni le port du masque ni la consommation assise ne sont
              possibles/imposables. Cette règle s'applique d'une part aux
              discothèques et aux bars, d'autre part aux activités sportives et
              culturelles pratiquées par des non-professionnels lorsqu'il n'y a
              pas de port de masque, comme les répétitions de fanfares. Elle ne
              s'applique pas aux jeunes de moins de 16 ans. Les personnes dont
              la vaccination complète, le rappel de vaccination ou la guérison
              ne remonte pas à plus de quatre mois sont exemptées de cette
              obligation de test. Les entreprises et les manifestations soumises
              à la règle des «2G» peuvent appliquer volontairement la règle des
              «2G+» et renoncer ainsi à l'obligation de porter un masque et de
              s'asseoir.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Quand un test rapide antigénique est-il utile?
            </h4>
            <p>
              Le test rapide antigénique permet de détecter très rapidement si
              une personne possède une charge virale élevée et donc si elle est
              hautement contagieuse. Il peut remplacer le test PCR, plus
              coûteux, et soulager les laboratoires. Néanmoins, même s'il est
              utilisé correctement, sa sensibilité est légèrement inférieure à
              celle du test PCR. Les personnes infectées présentant une charge
              virale très faible pourraient ainsi ne pas être détectées. C'est
              pourquoi le test PCR reste la méthode la plus fiable et sert de
              contrôle pour les tests rapides antigéniques.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui container'>
          <h5 className='graphicTitle testmethoden'>
            Vue d’ensemble des différents types de tests
          </h5>
          {fourColumnGrid && (
            <>
              <div className='tableWrapper' id='twoColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-pcr.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>PCR</div>
                    </div>
                  </div>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-pcr-schnell.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>Test PCR rapide</div>
                    </div>
                  </div>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-antigen.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>
                        Antigènique rapide
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    Dans les tests PCR classiques, les échantillons sont envoyés
                    dans des laboratoires afin de détecter la présence du
                    matériel génétique de l'agent pathogène. Pour ce faire,
                    certaines sections de la molécule d'ARN du patrimoine
                    génétique sont d'abord transformées par le virus en
                    fragments d'ADN correspondants, puis amplifiées et
                    analysées. Entre l'arrivée de l'échantillon et le résultat,
                    il faut généralement compter 3 heures, mais selon le
                    système, il est possible de tester jusqu'à 1000 échantillons
                    en même temps.{' '}
                  </div>
                  <div className='col'>
                    Les tests PCR rapides utilisent certes la même méthode, mais
                    avec des procédures spéciales et en tant qu'échantillon
                    unique. Certains de ces tests sont aussi sensibles que les
                    tests PCR classiques. Ils sont notamment commercialisés sous
                    la forme d'une sorte de mini-laboratoire (voir ci-dessous),
                    dans lequel tous les réactifs sont déjà présents dans un
                    tube et sont évalués dans un appareil de la taille d'une
                    machine à café. L'inconvénient est qu'il n'est possible
                    d’analyser qu'un seul échantillon à la fois.{' '}
                  </div>
                  <div className='col'>
                    Les tests antigéniques rapides peuvent également détecter
                    directement l'agent pathogène, par exemple un antigène
                    (protéine de la nucléocapside) du virus. Les résultats sont
                    soit obtenus sur place avec des échantillons individuels à
                    l'aide de la méthode des bandelettes réactives (voir
                    ci-dessous); ou alors, une analyse en laboratoire est
                    effectuée sur des appareils sophistiqués, capables de
                    traiter jusqu'à 300 échantillons par heure simultanément.
                    Cette dernière méthode, en raison de la logistique
                    nécessaire, est toutefois un peu plus lente.
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Application:</div>
                        <div className='colInsideRight'>
                          Pour toutes les personnes en cas de suspicion
                          d'infection (surtout les hôpitaux, les écoles, les EMS
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Application:</div>
                        )}

                        <div className='colInsideRight'>
                          Pour les tests individuels dans les cabinets médicaux
                          et les hôpitaux
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Application:</div>
                        )}

                        <div className='colInsideRight'>
                          Pour un contrôle rapide en cas de symptômes et un
                          dépistage des personnes en contact, des clusters
                          d'infection potentiels (par exemple dans les écoles,
                          les EMS) ainsi que pour le personnel de santé et le
                          personnel soignant.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Type de prélèvement:
                        </div>
                        <div className='colInsideRight'>
                          <span>
                            Frottis naso pharyngé ou nasal; salive (pour le test
                            PCR en pool)
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>
                            Type de prélèvement:
                          </div>
                        )}

                        <div className='colInsideRight'>
                          Frottis naso pharyngé
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>
                            Type de prélèvement:
                          </div>
                        )}

                        <div className='colInsideRight'>
                          Frottis naso pharyngé ou nasal
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Lieu d’analyse:
                        </div>
                        <div className='colInsideRight'>Laboratoire</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>
                            Lieu d’analyse:
                          </div>
                        )}
                        <div className='colInsideRight'>
                          Cabinet médical ou à l'hôpital, hors laboratoire
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>
                            Lieu d’analyse:
                          </div>
                        )}
                        <div className='colInsideRight'>
                          Sans laboratoire, directement dans des centres de
                          test, des cabinets médicaux, des pharmacies ou des
                          hôpitaux.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Précision:</div>
                        <div className='colInsideRight'>Très élevée</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Précision:</div>
                        )}
                        <div className='colInsideRight'>Très élevée</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Précision:</div>
                        )}
                        <div className='colInsideRight'>
                          Plus faible que les tests PCR
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Résultat en:</div>
                        <div className='colInsideRight'>3 h</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Résultat en:</div>
                        )}
                        <div className='colInsideRight'>20 min</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Résultat en:</div>
                        )}
                        <div className='colInsideRight'>15 min</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='tableWrapper second' id='twoColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-antigen_nase.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>Auto-test nasal</div>
                    </div>
                  </div>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-antikoerper.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>
                        Test rapide d'anticorps
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>
                <div className='row'>
                  <div className='col'>
                    Il s'agit aussi d'un test antigénique rapide, mais
                    l'échantillon est toujours un frottis nasal. De manière
                    générale, le prélèvement effectué par une personne non
                    professionnelle peut entraîner davantage d'erreurs.
                  </div>
                  <div className='col'>
                    Les tests rapides d'anticorps permettent de savoir si le
                    système immunitaire a réagi au virus. C'est le cas à un
                    stade très tardif de l'infection ou après une infection. La
                    plupart du temps, seule une classe d'anticorps, soit IgG
                    soit IgM, est détectée. Là encore, les tests rapides
                    proposent la méthode des bandelettes réactives avec résultat
                    directement sur place (voir ci-dessous) ou une analyse en
                    laboratoire, un peu plus longue en raison de la logistique,
                    avec plusieurs centaines d'échantillons à la fois.{' '}
                  </div>
                  <div className='col empty' />
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Application:</div>
                        <div className='colInsideRight'>
                          Pour tout le monde, afin de pouvoir se tester
                          régulièrement, même en l’absence de symptômes. Chaque
                          personne doit pouvoir obtenir cinq autotests par mois.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Application:</div>
                        )}
                        <div className='colInsideRight'>
                          Pour toute personne souhaitant une réponse rapide,
                          qu'elle ait déjà été en contact avec l'agent pathogène
                          ou non.{' '}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Type de prélèvement:
                        </div>
                        <div className='colInsideRight'>Frottis nasal</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>
                            Type de prélèvement:
                          </div>
                        )}
                        <div className='colInsideRight'>
                          Quelques gouttes de sang, généralement prélevées au
                          bout du doigt de la personne à tester
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Lieu d’analyse:
                        </div>
                        <div className='colInsideRight'>
                          À domicile, partout.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>
                            Lieu d’analyse:
                          </div>
                        )}
                        <div className='colInsideRight'>
                          Sur place, sans nécessiter des instruments de
                          laboratoire, par exemple dans les hôpitaux, les
                          cabinets médicaux ou les pharmacies.{' '}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Précision:</div>
                        <div className='colInsideRight'>
                          Élevé avec symptômes, probablement plus faible sans
                          symptômes
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Précision:</div>
                        )}
                        <div className='colInsideRight'>Élevée</div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Résultat en:</div>
                        <div className='colInsideRight'>15 min</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Résultat en:</div>
                        )}
                        <div className='colInsideRight'>20 min</div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>
              </div>
            </>
          )}
          {twoColumnGrid && (
            <>
              <div className='tableWrapper' id='twoColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-pcr.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>Test PCR</div>
                    </div>
                  </div>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-pcr-schnell.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>Test PCR rapide</div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    Dans les tests PCR classiques, les échantillons sont envoyés
                    dans des laboratoires afin de détecter la présence du
                    matériel génétique de l'agent pathogène. Pour ce faire,
                    certaines sections de la molécule d'ARN du patrimoine
                    génétique sont d'abord transformées par le virus en
                    fragments d'ADN correspondants, puis amplifiées et
                    analysées. Entre l'arrivée de l'échantillon et le résultat,
                    il faut généralement compter 3 heures, mais selon le
                    système, il est possible de tester jusqu'à 1000 échantillons
                    en même temps.
                  </div>
                  <div className='col'>
                    Les tests PCR rapides utilisent certes la même méthode, mais
                    avec des procédures spéciales et en tant qu'échantillon
                    unique. Certains de ces tests sont aussi sensibles que les
                    tests PCR classiques. Ils sont notamment commercialisés sous
                    la forme d'une sorte de mini-laboratoire (voir ci-dessous),
                    dans lequel tous les réactifs sont déjà présents dans un
                    tube et sont évalués dans un appareil de la taille d'une
                    machine à café. L'inconvénient est qu'il n'est possible
                    d’analyser qu'un seul échantillon à la fois.
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Application:</div>
                        <div className='colInsideRight'>
                          Pour toutes les personnes en cas de suspicion
                          d'infection (surtout les hôpitaux, les écoles, les EMS
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Application:</div>
                        )}

                        <div className='colInsideRight'>
                          Pour les tests individuels dans les cabinets médicaux
                          et les hôpitaux
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Type de prélèvement:
                        </div>
                        <div className='colInsideRight'>
                          <span>
                            Frottis naso pharyngé ou nasal; salive (pour le test
                            PCR en pool)
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>
                            Type de prélèvement:
                          </div>
                        )}

                        <div className='colInsideRight'>
                          Frottis naso pharyngé
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Lieu d’analyse:
                        </div>
                        <div className='colInsideRight'>Laboratoire</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>
                            Lieu d’analyse:
                          </div>
                        )}
                        <div className='colInsideRight'>
                          Cabinet médical ou à l'hôpital, hors laboratoire
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Précision:</div>
                        <div className='colInsideRight'>Très élevée</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Précision:</div>
                        )}
                        <div className='colInsideRight'>Très élevée</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Résultat en:</div>
                        <div className='colInsideRight'>3 h</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Résultat en:</div>
                        )}
                        <div className='colInsideRight'>20 min</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='tableWrapper second' id='twoColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-antigen.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>
                        Test antigénique rapide
                      </div>
                    </div>
                  </div>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-antigen_nase.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>Auto-test nasal</div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    Les tests antigéniques rapides peuvent également détecter
                    directement l'agent pathogène, par exemple un antigène
                    (protéine de la nucléocapside) du virus. Les résultats sont
                    soit obtenus sur place avec des échantillons individuels à
                    l'aide de la méthode des bandelettes réactives (voir
                    ci-dessous); ou alors, une analyse en laboratoire est
                    effectuée sur des appareils sophistiqués, capables de
                    traiter jusqu'à 300 échantillons par heure simultanément.
                    Cette dernière méthode, en raison de la logistique
                    nécessaire, est toutefois un peu plus lente.
                  </div>
                  <div className='col'>
                    Il s'agit aussi d'un test antigénique rapide, mais
                    l'échantillon est toujours un frottis nasal. De manière
                    générale, le prélèvement effectué par une personne non
                    professionnelle peut entraîner davantage d'erreurs.
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Application:</div>
                        <div className='colInsideRight'>
                          Pour un contrôle rapide en cas de symptômes et un
                          dépistage des personnes en contact, des clusters
                          d'infection potentiels (par exemple dans les écoles,
                          les EMS) ainsi que pour le personnel de santé et le
                          personnel soignant.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Application:</div>
                        )}
                        <div className='colInsideRight'>
                          Pour tout le monde, afin de pouvoir se tester
                          régulièrement, même en l’absence de symptômes. Chaque
                          personne doit pouvoir obtenir cinq autotests par mois.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Type de prélèvement:
                        </div>
                        <div className='colInsideRight'>
                          Frottis naso pharyngé ou nasal
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>
                            Type de prélèvement:
                          </div>
                        )}
                        <div className='colInsideRight'>Frottis nasal</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Lieu d’analyse:
                        </div>
                        <div className='colInsideRight'>
                          Sans laboratoire, directement dans des centres de
                          test, des cabinets médicaux, des pharmacies ou des
                          hôpitaux.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>
                            Lieu d’analyse:
                          </div>
                        )}
                        <div className='colInsideRight'>
                          À domicile, partout.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Précision:</div>
                        <div className='colInsideRight'>
                          Plus faible que les tests PCR
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Précision:</div>
                        )}
                        <div className='colInsideRight'>
                          Élevé avec symptômes, probablement plus faible sans
                          symptômes
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Résultat en:</div>
                        <div className='colInsideRight'>15 min</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Résultat en:</div>
                        )}
                        <div className='colInsideRight'>15 min</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='tableWrapper third' id='twoColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-antikoerper.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>
                        Test rapide d'anticorps
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>
                <div className='row'>
                  <div className='col'>
                    Les tests rapides d'anticorps permettent de savoir si le
                    système immunitaire a réagi au virus. C'est le cas à un
                    stade très tardif de l'infection ou après une infection. La
                    plupart du temps, seule une classe d'anticorps, soit IgG
                    soit IgM, est détectée. Là encore, les tests rapides
                    proposent la méthode des bandelettes réactives avec résultat
                    directement sur place (voir ci-dessous) ou une analyse en
                    laboratoire, un peu plus longue en raison de la logistique,
                    avec plusieurs centaines d'échantillons à la fois.
                  </div>
                  <div className='col empty' />
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Application:</div>
                        <div className='colInsideRight'>
                          Pour toute personne souhaitant une réponse rapide,
                          qu'elle ait déjà été en contact avec l'agent pathogène
                          ou non
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Type de prélèvement:
                        </div>
                        <div className='colInsideRight'>
                          Quelques gouttes de sang, généralement prélevées au
                          bout du doigt de la personne à tester
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Lieu d’analyse:
                        </div>
                        <div className='colInsideRight'>
                          Sur place, sans nécessiter des instruments de
                          laboratoire, par exemple dans les hôpitaux, les
                          cabinets médicaux ou les pharmacies.{' '}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Précision:</div>
                        <div className='colInsideRight'>Élevée</div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Résultat en:</div>
                        <div className='colInsideRight'>20 min</div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>
              </div>
            </>
          )}
          {oneColumnGrid && (
            <>
              <div className='tableWrapper' id='oneColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-pcr.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>Test PCR</div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    Dans les tests PCR classiques, les échantillons sont envoyés
                    dans des laboratoires afin de détecter la présence du
                    matériel génétique de l'agent pathogène. Pour ce faire,
                    certaines sections de la molécule d'ARN du patrimoine
                    génétique sont d'abord transformées par le virus en
                    fragments d'ADN correspondants, puis amplifiées et
                    analysées. Entre l'arrivée de l'échantillon et le résultat,
                    il faut généralement compter 3 heures, mais selon le
                    système, il est possible de tester jusqu'à 1000 échantillons
                    en même temps.{' '}
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Application:</div>
                        <div className='colInsideRight'>
                          Pour toutes les personnes en cas de suspicion
                          d'infection (surtout les hôpitaux, les écoles, les EMS
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Type de prélèvement:
                        </div>
                        <div className='colInsideRight'>
                          <span>
                            Frottis naso pharyngé ou nasal; salive (pour le test
                            PCR en pool)
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Lieu d’analyse:
                        </div>
                        <div className='colInsideRight'>Laboratoire</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Précision:</div>
                        <div className='colInsideRight'>Très élevée</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Résultat en:</div>
                        <div className='colInsideRight'>3 h</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='tableWrapper' id='oneColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-pcr-schnell.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>Test PCR rapide</div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    Les tests PCR rapides utilisent certes la même méthode, mais
                    avec des procédures spéciales et en tant qu'échantillon
                    unique. Certains de ces tests sont aussi sensibles que les
                    tests PCR classiques. Ils sont notamment commercialisés sous
                    la forme d'une sorte de mini-laboratoire (voir ci-dessous),
                    dans lequel tous les réactifs sont déjà présents dans un
                    tube et sont évalués dans un appareil de la taille d'une
                    machine à café. L'inconvénient est qu'il n'est possible
                    d’analyser qu'un seul échantillon à la fois.{' '}
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Application:</div>
                        <div className='colInsideRight'>
                          Pour les tests individuels dans les cabinets médicaux
                          et les hôpitaux
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Type de prélèvement:
                        </div>
                        <div className='colInsideRight'>
                          Frottis naso pharyngé
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Lieu d’analyse:
                        </div>
                        <div className='colInsideRight'>
                          Cabinet médical ou à l'hôpital, hors laboratoire
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Précision:</div>
                        <div className='colInsideRight'>Très élevée</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Résultat en:</div>
                        <div className='colInsideRight'>20 min</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='tableWrapper' id='oneColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-antigen.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>
                        Antigènique rapide
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    Les tests antigéniques rapides peuvent également détecter
                    directement l'agent pathogène, par exemple un antigène
                    (protéine de la nucléocapside) du virus. Les résultats sont
                    soit obtenus sur place avec des échantillons individuels à
                    l'aide de la méthode des bandelettes réactives (voir
                    ci-dessous); ou alors, une analyse en laboratoire est
                    effectuée sur des appareils sophistiqués, capables de
                    traiter jusqu'à 300 échantillons par heure simultanément.
                    Cette dernière méthode, en raison de la logistique
                    nécessaire, est toutefois un peu plus lente.
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Application:</div>
                        <div className='colInsideRight'>
                          Pour un contrôle rapide en cas de symptômes et un
                          dépistage des personnes en contact, des clusters
                          d'infection potentiels (par exemple dans les écoles,
                          les EMS) ainsi que pour le personnel de santé et le
                          personnel soignant.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Type de prélèvement:
                        </div>
                        <div className='colInsideRight'>
                          Frottis naso pharyngé ou nasal
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Lieu d’analyse:
                        </div>
                        <div className='colInsideRight'>
                          Sans laboratoire, directement dans des centres de
                          test, des cabinets médicaux, des pharmacies ou des
                          hôpitaux.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Précision:</div>
                        <div className='colInsideRight'>
                          Plus faible que les tests PCR
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Résultat en:</div>
                        <div className='colInsideRight'>15 min</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='tableWrapper' id='oneColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-antigen_nase.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>Auto-test nasal</div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    Il s'agit aussi d'un test antigénique rapide, mais
                    l'échantillon est toujours un frottis nasal. De manière
                    générale, le prélèvement effectué par une personne non
                    professionnelle peut entraîner davantage d'erreurs.
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Application:</div>
                        <div className='colInsideRight'>
                          Pour tout le monde, afin de pouvoir se tester
                          régulièrement, même en l’absence de symptômes. Chaque
                          personne doit pouvoir obtenir cinq autotests par mois.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Type de prélèvement:
                        </div>
                        <div className='colInsideRight'>Frottis nasal</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Lieu d’analyse:
                        </div>
                        <div className='colInsideRight'>
                          À domicile, partout.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Précision:</div>
                        <div className='colInsideRight'>Élevée</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Résultat en:</div>
                        <div className='colInsideRight'>15 min</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='tableWrapper' id='oneColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-antikoerper.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>
                        Test rapide d'anticorps
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    Les tests rapides d'anticorps permettent de savoir si le
                    système immunitaire a réagi au virus. C'est le cas à un
                    stade très tardif de l'infection ou après une infection. La
                    plupart du temps, seule une classe d'anticorps, soit IgG
                    soit IgM, est détectée. Là encore, les tests rapides
                    proposent la méthode des bandelettes réactives avec résultat
                    directement sur place (voir ci-dessous) ou une analyse en
                    laboratoire, un peu plus longue en raison de la logistique,
                    avec plusieurs centaines d'échantillons à la fois.{' '}
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Application:</div>
                        <div className='colInsideRight'>
                          Pour toute personne souhaitant une réponse rapide,
                          qu'elle ait déjà été en contact avec l'agent pathogène
                          ou non
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Type de prélèvement:
                        </div>
                        <div className='colInsideRight'>
                          Quelques gouttes de sang, généralement prélevées au
                          bout du doigt de la personne à tester
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>
                          Lieu d’analyse:
                        </div>
                        <div className='colInsideRight'>
                          Sur place, sans nécessiter des instruments de
                          laboratoire, par exemple dans les hôpitaux, les
                          cabinets médicaux ou les pharmacies.{' '}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Précision:</div>
                        <div className='colInsideRight'>Élevée</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Résultat en:</div>
                        <div className='colInsideRight'>20 min</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui ta text container'>
          <h4 className='chapter'>
            {/* <b>1</b> */}
            {/* <br /> */}
            Quelle est la fiabilité des tests rapides antigéniques?
          </h4>
          <p>
            Les tests rapides antigéniques peuvent entraîner un nombre plus
            élevé de résultats faussement négatifs ou faussement positifs. Cela
            dépend toutefois de la sensibilité et de la spécificité de chaque
            kit de test (voir graphique). C'est pourquoi il est important, en
            cas de résultat positif, de toujours effectuer par la suite un test
            PCR en guise de confirmation. En cas de résultat négatif, il faut,
            si possible, répéter le test rapide antigénique deux à quatre jours
            plus tard.
          </p>
        </div>
      </div>

      <div
        className='ui vertical fitted segment'
        style={{ backgroundColor: '#EFECE0' }}
      >
        <div
          className='ui text container'
          style={{ marginTop: '1rem', marginBottom: '1rem' }}
        >
          <div className='ta text'>
            {/* <h4 className='graphicTitle'>
              Wie zuverlässig sind Antigen-Schnelltests
            </h4>
            <div className='graphicSub'>
              Diese Tests sind sehr hilfreich für den Nachweis in den ersten
              Tagen nach Symptombeginn und für Aussagen über die
              Ansteckungsgefahr, aber nicht ganz so genau wie PCR-Tests.
            </div> */}

            <Image
              file={
                browserCheck.isMobile
                  ? require('../../images/flussdiagramm-antigentest-mobile.svg')
                  : require('../../images/flussdiagramm-antigentest-desktop.svg')
              }
              className='cbImage flussdiagramm'
              // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
              // source='Quelle: Robert Koch Institut'
            />
            <div className='graphicSub flussdiagramm'>
              <div className='calcWrapper'>
                <div className='row'>
                  <div className='colAntigen divBox'>
                    <div className='divLeft' />
                    <div className='divRight' />
                  </div>
                  <div className='colAntigen divBox'>
                    <div className='divLeft' />
                    <div className='divRight' />
                  </div>
                </div>
                <div className='row'>
                  <div className='colAntigen divBox'>
                    <div className='divLeft' />
                    <div className='divRight' />
                  </div>
                  <div className='colAntigen textBox'>
                    <div className='text'>
                      Quelle est la probabilité que je sois infecté(e) si le
                      résultat de mon test est négatif:{' '}
                      <span className='number petrol bold'>2,2%</span>. (9020
                      tests négatifs au total/200 d'entre eux sont des faux
                      négatifs = 2,2%)
                    </div>
                  </div>
                  <div className='number petrol bold' />
                </div>
                <div className='row'>
                  <div className='colAntigen textBox'>
                    <div className='text'>
                      Quelle est la probabilité que je sois infecté(e) si le
                      résultat de mon test est positif:{' '}
                      <span className='number red bold'>81,6%</span>. (980 tests
                      positifs au total/800 d'entre eux sont corrects = 81,6%)
                    </div>
                  </div>
                  {/* <div className='calcDescription'>(980 positive Tests total/ 800 davon sind richtig = 81,6%)</div> */}
                </div>
              </div>
              <br />
              <p>
                La <span className='bold'>sensibilité</span> est la proportion
                de personnes ayant un résultat positif parmi les personnes
                infectées. La <span className='bold'>spécificité</span> est la
                proportion de personnes ayant un résultat négatif parmi les
                personnes non infectées.
                <br />
                <b>Exemple de calcul</b>: 1000 personnes sur 10'000 sont
                effectivement infectées. Le test rapide antigénique a une
                sensibilité de 80% et une spécificité de 98%. Sensibilité: 1000
                personnes infectées (dont 800 correctement positives/200
                faussement négatives). Spécificité: 9000 personnes non infectées
                (dont 8820 correctement négatives/180 faussement positives)
              </p>
              {/* <p>
                <span className='bold'>Rechenbeispiel:</span> 1000 von 10’000
                Personen sind tatsächlich infiziert. Antigen-Schnelltest hat
                eine Sensitivität von 80% und Spezifität von 98%.
                <br />
                Sensitivität: 1000 Infizierte (davon 800 richtig positiv / 200
                falsch negativ)
                <br />
                Spezifität: 9000 Nicht-Infizierte (davon 8820 richtig negativ /
                180 falsch positiv)
              </p> */}
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Combien de temps un test PCR reste-t-il positif chez les personnes
              guéries ?
            </h4>
            <p>
              Il est impossible de répondre à cette question de manière
              générale. Différentes études montrent que, dans de rares cas, un
              test PCR peut encore se révéler positif vingt à trente jours après
              le début de l'infection. En cause: des «débris viraux» présents
              dans l'échantillon. La situation est différente pour les tests
              rapides antigéniques, car ils ne révèlent l'infection que pendant
              une courte période. Avec le variant Omicron, la probabilité de se
              réinfecter ultérieurement est toutefois nettement plus élevée
              qu'avec le variant Delta.
            </p>

            <h5 className='graphicTitle abstrich'>
              Quand opter pour quel type de test?
            </h5>
            <Image
              file={
                browserCheck.isMobile
                  ? require('../../images/timeline-mobile.svg')
                  : require('../../images/timeline.svg')
              }
              className='cbImage timeline'
              // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
              // source='Quellen: «Süddeutsche Zeitung», Robert Koch Institut, Abbott'
            />
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Un test rapide d'anticorps peut-il indiquer si les personnes
              infectées sont toujours contagieuses ?
            </h4>
            <p>
              Non. La présence d'anticorps dans le sang indique uniquement
              qu'une personne a déjà été en contact avec le virus ou qu'elle a
              été vaccinée. Les tests rapides d'anticorps ne permettent pas de
              déterminer le moment de l'infection. Ils ne permettent pas non
              plus de déterminer s'il s’agit d’une réinfection récente.
            </p>

            <p>
              Les tests rapides d'anticorps fonctionnent à l'aide de bandelettes
              réactives. Cela permet de connaître le résultat de l'échantillon
              de sang à analyser directement sur place, par exemple dans une
              pharmacie ou un cabinet médical, en l’espace de vingt minutes
              environ. Mais il se peut aussi qu'en raison de la logistique, une
              analyse de laboratoire un peu plus longue soit effectuée avec
              plusieurs centaines d'échantillons à la fois.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Les tests PCR salivaires groupés («pooling») sont-ils meilleurs
              que les tests rapides antigéniques?
            </h4>
            <p>
              Les tests groupés, faciles à réaliser, conviennent généralement
              surtout aux entreprises, aux écoles ou aux établissements de
              santé. Selon l'OFSP, les tests PCR salivaires groupés sont plus
              fiables que les tests rapides antigéniques. Ils détectent
              également les infections plus tôt. Les tests PCR salivaires
              groupés permettent ainsi d'identifier les cas positifs par le
              biais de la salive jusqu'à trois ou quatre jours avant
              l'apparition des symptômes. Le «pooling» et l'analyse durent en
              général entre huit et vingt-quatre heures. De leur côté, les tests
              rapides antigéniques fournissent un résultat immédiat permettant
              de déterminer rapidement, dans les quatre premiers jours de la
              maladie, si une personne présentant des symptômes pseudo-grippaux
              a effectivement été infectée par le Sars-CoV-2 ou non.
            </p>
          </div>
        </div>

        <Image
          file={require('../../images/spucktest-schule.jpg')}
          className='cbImage schulklasse'
          aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
          source="Test hebdomadaire de pool salivaire PCR, des élèves de l'école cantonale de Wiedikon à Zurich prennent un liquide salé dans la bouche pendant une minute afin de recueillir de la salive. Photo: KEYSTONE/Gaetan Bally"
        />
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Est-ce que tout le monde peut participer à un test PCR salivaire
              groupé?
            </h4>
            <p>
              Depuis peu, l'OFSP encourage désormais aussi les tests PCR
              salivaires groupés pour les individus asymptomatiques. Lorsqu’une
              personne se fait tester, c’est ce type de test qui est recommandé
              pour l’obtention d’un certificat Covid et non un test rapide
              antigénique. En effet, un test PCR salivaire groupé ne nécessite
              qu'un peu de salive, contrairement au test rapide antigénique pour
              lequel il faut se faire insérer un long bâtonnet dans le nez. Les
              échantillons peuvent être remis aux centres de test participant au
              projet{' '}
              <Link allowWordWrap href='https://www.pooltests.ch/de'>
                «tests groupés pour tous»
              </Link>{' '}
              . Parmi les participants figurent également des pharmacies, des
              cabinets médicaux, des services de soins à domicile ou encore des
              laboratoires.
            </p>
            <p>
              En cas de résultat négatif, le certificat Covid est valable
              septante-deux heures à compter du dépôt de la salive. En cas de
              résultat positif, les personnes testées du groupe sont informées
              par e-mail et doivent se rendre à un test individuel (PCR ou test
              rapide antigénique). Les coûts de ces tests individuels sont pris
              en charge par la Confédération. Si ce deuxième test est négatif,
              le centre de dépistage concerné délivre alors un certificat Covid.
            </p>
          </div>
        </div>
      </div>
      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Le nouveau variant Omicron peut-il être détecté par un test PCR
              ordinaire?
            </h4>
            <p>
              Pour détecter les variants, il faut soit recourir à un séquençage,
              soit utiliser un test PCR spécial permettant d’identifier les
              différentes mutations de chaque variant. Pour le variant Omicron,
              la filiale de Roche TIB Molbiol a récemment développé un kit de
              test à des fins de recherche. Il existe en outre d'autres kits de
              test qui permettent de détecter l'une des mutations du variant
              Omicron et qui peuvent ainsi servir d'indice pour une
              identification plus poussée.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Un test rapide antigénique peut-il être positif peu après la
              vaccination par ARNm?
            </h4>
            <p>
              Non, car un test rapide antigénique réagit à la protéine de la
              nucléocapside du virus lorsqu’un échantillon est déposé sur la
              bandelette de test. En revanche, après une vaccination par ARNm,
              les cellules produisent la protéine spike du virus, qui n'est pas
              pertinente pour les tests rapides.
            </p>
            <YoutubeEmbed embedId='Ms153kckhkQ' />

          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Les personnes vaccinées ou guéries doivent-elles également se
              faire tester pour un voyage à l'étranger?
            </h4>
            <p>
              En raison de la situation actuelle, des dispositions particulières
              ont été mises en place pour l'entrée en Suisse. À quelques
              exceptions près, toutes les personnes entrant dans le pays doivent
              présenter un formulaire d'entrée et un résultat de test négatif.
              Il est par ailleurs possible qu’elles doivent être placées en
              quarantaine. Étant donné que le test PCR des personnes guéries
              peut encore se révéler positif des semaines après l'infection,
              l'OFSP accorde une exception aux personnes guéries: pour cela,
              elles doivent simplement présenter une attestation médicale
              prouvant qu’elles ont contracté le Covid-19 au cours des trente
              derniers jours et qu'elles ne présentent actuellement aucun
              symptôme. Dans ce cas, les personnes guéries peuvent présenter un
              test rapide antigénique négatif datant de vingt-quatre heures au
              maximum, par exemple pour voyager en avion.{' '}
            </p>
          </div>
        </div>
      </div>

      {/* <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Die Streifen-Schnelltests für Antigene sehen fast wie diejenigen
              von Schwangerschaftstests aus, der PCR-Schnelltest ist dagegen ein
              kleines «Labor im Röhrchen». Die Antigen-Schnelltests und
              PCR-Schnelltests benötigen zum Beispiel Abstriche aus dem
              Nasen-Rachen-Raum. Inzwischen gibt es aber auch Tests mit Speichel
              oder nur mit einem Nasen-Abstrich. Geplant sind in Zukunft auch
              Selbsttest, die das Bundesamt für Gesundheit aber bisher noch
              nicht genehmigt hat.
            </p>
            <h4 className='graphicTitle abstrich'>
              Nasen-Rachen-Abstrich für eine Covid-19-Diagnostik
            </h4>
            <Image
              file={require('../../images/nasen-rachen-abstrich-desktop.svg')}
              className='cbImage abstrich'
              aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
            />

            <ol className='simple-list'>
              <li>Nasenhöhle</li>
              <li>Nasenrachen</li>
              <li>Mundrachen</li>
            </ol>
            <p>
              Wie aussagekräftig, präzis und teuer diese unterschiedlichen
              Methoden sind, zeigt ein Vergleich der verschiedenen Schnelltests
              mit dem klassischen PCR-Test. Der Antigen-Schnelltest ist zum
              Beispiel ein einfaches Verfahren, um zu erkennen, ob eine Person
              eine hohe Viruslast hat und deshalb hochansteckend ist. Er könnte
              teilweise teurere PCR-Tests ersetzen und Labore entlasten − etwa
              in Schulen, Pflegeheimen oder bei Reiserückkehrern. Dennoch ist
              selbst bei korrekter Application die Sensitivität etwas geringer als
              beim PCR-Test. Infizierte mit sehr niedriger Viruslast werden
              dadurch möglicherweise nicht erkannt.
            </p>
          </div>
        </div>
      </div> */}

      <Footer
        mailTo='interactif@tamedia.ch'
        locale='fr'
        hidePortfolioTeaser
        articleId={ARTICLE_ID}
        questions={[
          'Le contenu était-il informatif?',
          'Comment jugez-vous la présentation?'
        ]}
        credits={[
          ['Texte et recherche', 'Barbara Reye'],
          ['Conception et réalisation', 'Patrick Vögeli'],
          [
            'Sources',
            'Robert Koch-Institut, Roche, Université de Zurich, EPFL, Covid-19 Science Taskforce, OFSP'
          ]
        ]}
      />
    </div>
  )
}
